{
  "name": "@eyevinn/www",
  "version": "1.13.0",
  "description": "Eyevinn main website",
  "scripts": {
    "prebuild": "node scripts/generate-blog-index.js",
    "start": "npm run prebuild && parcel src/*.html src/blog.html --no-cache",
    "build": "npm run prebuild && parcel build --public-url ./ src/*.html src/blog.html --no-cache && node scripts/inject-blog-cards.js && node scripts/build-blog-scripts.js && mkdir -p dist/whitepapers && (cp src/whitepapers/*.pdf dist/whitepapers/ 2>/dev/null || true) && node scripts/inject-content-cards.js && mkdir -p dist/blog/images && (cp -r src/blog/images/* dist/blog/images/ 2>/dev/null || true) && cp src/blog/blog-index.json dist/blog/ && mkdir -p dist/images && (cp -r images/* dist/images/ 2>/dev/null || true) && node scripts/generate-sitemap.js && node scripts/optimize-images.js && mkdir -p dist/vendor dist/fonts/inter && cp src/vendor/*.css dist/vendor/ && cp src/fonts/inter/*.woff2 dist/fonts/inter/ && cp src/robots.txt dist/ && cp src/llms.txt dist/ && cp src/static/404.html dist/",
    "postversion": "git push && git push --tags",
    "test:visual": "playwright test tests/visual/",
    "test:smoke": "playwright test tests/smoke/",
    "test:all": "playwright test",
    "test:update-snapshots": "playwright test --update-snapshots",
    "type-check": "tsc --noEmit"
  },
  "author": "Eyevinn Technology <webmaster@eyevinn.se>",
  "license": "ISC",
  "devDependencies": {
    "@axe-core/playwright": "^4.13.0",
    "@parcel/packager-raw-url": "^2.16.4",
    "@parcel/packager-xml": "^2.16.4",
    "@parcel/transformer-jsonld": "^2.16.4",
    "@parcel/transformer-xml": "^2.16.4",
    "@playwright/test": "^1.62.1",
    "@types/node": "^26.2.0",
    "axios": "^1.19.0",
    "buffer": "^6.0.3",
    "chalk": "^6.0.0",
    "cheerio": "^1.2.0",
    "cli-progress": "^3.12.0",
    "gray-matter": "^4.0.3",
    "marked": "^18.0.9",
    "parcel": "^2.16.4",
    "prettier": "^3.9.6",
    "process": "^0.11.10",
    "rss-parser": "^3.13.0",
    "serve": "^14.2.6",
    "slugify": "^1.6.9",
    "turndown": "^7.2.4",
    "turndown-plugin-gfm": "^1.0.2",
    "typescript": "^7.0.2",
    "yaml": "^2.9.0"
  },
  "dependencies": {
    "@aws-sdk/client-cognito-identity": "^3.980.0",
    "@aws-sdk/client-sns": "^3.980.0",
    "@aws-sdk/credential-provider-cognito-identity": "^3.972.3"
  },
  "overrides": {
    "fast-xml-parser": "^5.8.0"
  }
}
